import { Typography } from '@mui/material';
import { branding } from 'app/config';
import type React from 'react';
import DocumentTitle from 'react-document-title';
import styled from 'styled-components';

export type GenericProps = {
  readonly title?: string;
  readonly message?: string;
  readonly children?: React.ReactNode;
};

const Container = styled('div')`
  padding: ${({ theme }) => theme.spacing(6)};
`;

const Generic: React.FC<GenericProps> = (props: GenericProps) => {
  const { title } = props;

  return (
    <Container>
      <DocumentTitle title={title ?? 'Please Reload'} />
      <Typography variant="h4" align="center" gutterBottom>
        Whoops!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Looks like something went wrong, please reload the page.
      </Typography>
      {branding.supportEmail && (
        <Typography variant="body1">
          Still not working? Contact support here:{' '}
          <a href={`mailto:${branding.supportEmail}`}>{branding.supportEmail}</a>.
        </Typography>
      )}
    </Container>
  );
};

export default Generic;
